import { render } from "./vPublication.vue?vue&type=template&id=64094e2e&scoped=true"
import script from "./vPublication.vue?vue&type=script&lang=js"
export * from "./vPublication.vue?vue&type=script&lang=js"

import "./vPublication.vue?vue&type=style&index=0&id=64094e2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64094e2e"]])

export default __exports__